import { Check } from '@insify/design-system/icons';
import { headingSm, textLgSemibold, textMd, textSm } from '@insify/design-system/typography';
import clsx from 'clsx';

import { IconList } from '../../../../components/IconList';

import styles from './overlay.module.css';

import type React from 'react';

const ShopOverlayContainer: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => {
  return <div className={clsx(className, styles.overlayContainer)}>{children}</div>;
};

const ShopOverlayBulletPoints: React.FC<{ className?: string; bulletPoints: ListItem[] }> = ({
  className,
  bulletPoints,
}) => {
  return (
    <ul className={clsx(className, styles.overlayBulletPoints)}>
      {bulletPoints.map(({ key, element }) => (
        <li className={clsx(textMd, styles.overlayBulletPointItem)} key={key}>
          <Check width={20} height={24} className={styles.check} />
          {element}
        </li>
      ))}
    </ul>
  );
};

const ShopOverlayBulletPointHighlight: React.FC<{ className?: string; children?: React.ReactNode }> = ({
  className,
  children,
}) => {
  return <span className={clsx(className, styles.bulletPointHighlight)}>{children}</span>;
};

const ShopOverlayHeading: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => {
  return <h2 className={clsx(className, headingSm, styles.overlayHeading)}>{children}</h2>;
};

const ShopOverlayCard: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => {
  return <div className={clsx(className, styles.overlayCard)}>{children}</div>;
};

const ShopOverlayCardHeading: React.FC<{ className?: string; children: React.ReactNode }> = ({
  className,
  children,
}) => {
  return <h3 className={clsx(className, textLgSemibold, styles.overlayCardHeading)}>{children}</h3>;
};

const ShopOverlayCardListWithIcon: React.FC<{
  items: Array<{ key: string; Icon: React.FC<React.SVGProps<SVGSVGElement>>; label: React.ReactNode }>;
}> = ({ items }) => {
  return (
    <IconList
      kind='big'
      list={items.map(({ Icon, label }) => ({
        Icon,
        Body: () => <span className={textSm}>{label}</span>,
      }))}
    />
  );
};

type ListItem = { key: string; element: React.ReactNode };

export {
  ShopOverlayContainer,
  ShopOverlayHeading,
  ShopOverlayBulletPoints,
  ShopOverlayBulletPointHighlight,
  ShopOverlayCard,
  ShopOverlayCardHeading,
  ShopOverlayCardListWithIcon,
};
